import { useContext } from 'react';
import LandingContext from 'src/contexts/LandingContext/LandingContext';

const useLanding = () => {
  return useContext(LandingContext);
};

export default useLanding;
